const QUERY_PARAM_PREFIX = 'query-param'

const handleSlug = (type, slug) => {
  switch (type) {
    case 'page':
      return `/${slug}`
    case 'location':
      return `/locations/${slug}`
    case 'appointment':
      return `/services/${slug}`
    case 'service':
      return `/services/${slug}`
    case 'editorial':
      return `/article/${slug}`
    case 'team':
      return `/team/${slug}`
    case 'join':
      return `/join/${slug}`
    default:
      return `/${slug}`
  }
}

const setLatestUrlQueryParams = () => {
    if(window) {
      const urlParams = new URLSearchParams(window.location.search)
      urlParams.forEach((value, key) => {
        sessionStorage.setItem(`${QUERY_PARAM_PREFIX}-${key}`, value)
      })
  }
}


const getLatestUrlQueryParams = () => {
  if (window) {
    setLatestUrlQueryParams()

    const queryParams: Record<string, string> = {}

    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith(QUERY_PARAM_PREFIX)) {
        const paramKey = key.replace(`${QUERY_PARAM_PREFIX}-`, '')
        queryParams[paramKey] = sessionStorage.getItem(key) || ''
      }
    })

    return queryParams
  }

  return {}
}

function toPlainText(blocks = []) {
  return blocks
    .map(block => {
      if (block._type !== 'block' || !block.children) {
        return ''
      }
      return block.children.map(child => child.text).join('')
    })
    .join('\n\n')
}

module.exports = {
  handleSlug,
  setLatestUrlQueryParams,
  getLatestUrlQueryParams,
  toPlainText,
}
